import API from "../config/api.js";

export default function EventCard({ event }) {
  const getImageUrl = (path) => {
    if (!path) return "/assets/img/350x350.png";
    return `${API.baseUrl}/${path.replace("original.jpg", "350x350.jpg")}`;
  };

  const imageSrc = getImageUrl(event.image);

  const getEventDate = () => {
    if (!event?.date) return null;

    const fullDate = `${event.date}${event.time ? `T${event.time}` : ""}`;
    const parsed = new Date(fullDate);

    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }

    const fallback = new Date(event.date);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  };

  const eventDate = getEventDate();

  const dayNumber = eventDate
    ? String(eventDate.getDate()).padStart(2, "0")
    : "--";

  const dayShort = eventDate
    ? eventDate.toLocaleDateString("en-US", { weekday: "short" })
    : "---";

  const formatTime = (time) => {
    if (!time) return "";

    const [hours = "0", minutes = "0"] = String(time).split(":");
    const date = new Date();
    date.setHours(Number(hours), Number(minutes), 0, 0);

    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const imageLink = event?.url || "#";
  const replayLink = event?.description || "";

  return (
    <div
      className={`card rounded-4 h-100 event-${event.idevent} animate__animated animate__fadeIn animate__slow`}
    >
      <a
        href={imageLink}
        target="_blank"
        rel="noreferrer"
        className="text-decoration-none"
      >
        <div className="p-2 position-relative">
          <img
            src={imageSrc}
            alt={event.title || ""}
            className="w-100 h-100 rounded-3"
            width="350"
            height="350"
            onError={(e) => {
              e.currentTarget.src = "/assets/img/350x350.png";
            }}
          />

          <div className="position-absolute top-0 start-0">
            <div
              className="bg-white text-dark rounded py-2 text-center m-3 p-1"
              style={{ width: "60px", height: "60px" }}
            >
              <strong>{dayNumber}</strong>
              <br />
              {dayShort}
            </div>
          </div>

          <div className="position-absolute m-2 p-3 bottom-0 start-0 end-0 bg-dark-gradient-bottom rounded">
            <h6 className="mb-0 text-white mt-4">{event.title}</h6>
          </div>
        </div>
      </a>

      <div className="card-footer bg-transparent p-3">
        <div className="row align-items-center">
          <div className="col-auto">
            {replayLink ? (
              <a
                href={replayLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-sm btn-outline-primary"
                style={{ transform: "none" }}
              >
                Watch Replay
              </a>
            ) : (
              <a
                href={imageLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn-sm btn-outline-primary"
                style={{ transform: "none" }}
              >
                Open Event
              </a>
            )}
          </div>

          <div className="col action-buttons text-end">
            <small style={{ fontSize: "12px" }}>
              {event.time ? `${formatTime(event.time)} (EST)` : ""}
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}